import React, { FC, useCallback } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { useDispatch } from 'react-redux'
import { GreyButton } from 'components/Button'
import { push } from 'connected-react-router'
import { MainHeadline } from 'components/Typography'
import { DepositHistoryList } from 'components/List'

const DepositHistoryTemplate: FC = () => {
  const dispatch = useDispatch()
  const backToRevenue = useCallback(() => dispatch(push('/account/revenue')), [])

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'入金履歴明細一覧'} />
      <Spacer size={24} />
      <DepositHistoryList />
      <Spacer size={24} />
      <GreyButton label={'売上確認ページに戻る'} onClick={backToRevenue} size={'medium'} type={'outlined'} />
      <Spacer size={72} />
    </div>
  )
}

export default DepositHistoryTemplate
